import axios from "axios";

export const skipInsuranceCoverageRequest = async (): Promise<void> => {
  await axios.post(`/api/checkins/insurance_coverages`, { skipped: true });
};

export const skipInsuranceCoverageNewRequest = async (): Promise<void> => {
  await axios.post(`/api/checkins/insurance_coverages_news`, { skipped: true });
};

export const skipInsuranceCoverageSaveRequest = async (params: {
  patient_id: string;
  appointment_id?: string;
}): Promise<void> => {
  await axios.post(`/api/checkins/save_insurances`, {
    skipped: true,
    patient_id: params.patient_id,
    appointment_id: params.appointment_id,
  });
};
